import React, {Component} from 'react';
import Modal from '../../cmp/Modal';
import Label from '../../auth/components/Label';
import {connect} from 'react-redux';
import {actionMergeSetting} from '../../../redux/settings/settingsAction';
import {post} from '../../../api';
import {FormattedMessage} from 'react-intl';

class CustomCouponModal extends Component {


    state = {
        coupon_code: undefined,
        loading: false
    }
    createCoupon = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState({loading: true});
        post('/coupon', {
            coupon_code: this.state.coupon_code,
            old_coupon: this.props.editing_coupon,
        }).then((result) => {
            if (result.coupon) {
                const my_coupons = this.props.my_coupons.map((item) => {
                    if (item.coupon === this.props.editing_coupon) {
                        return {...item, coupon: result.coupon}
                    } else {
                        return item;
                    }
                });
                this.props.updateSetting({my_coupons});
                this.props.onClose();
            } else if (result.error) {
                this.setState({error: result.error});
            }
            this.setState({loading: false});
        }).catch((e) => {
            this.setState({loading: false});
        });
    }

    onInput = (e) => {
        this.setState(({coupon_code: e.target.value}));
    }

    close = () => {
        this.setState({coupon_code: undefined, loading: false});
        this.props.onClose();
    }

    render() {
        return (
            <Modal onSubmit={this.createCoupon}
                   visible={this.props.visible}
                   onCancel={this.close}
                   title={<FormattedMessage id={'changeCoupon'}/>}
                   onOk={this.createCoupon}
                   confirmLoading={this.state.loading}
                   disabled={!this.state.coupon_code}
                   okText={<FormattedMessage id={'Update'}/>}
                   cancelText={<FormattedMessage id={'Cancel'}/>}
            >
                <p>
                    <FormattedMessage id={'changeCouponModalDescription'}/>
                </p>
                <div className="form-group">
                    <Label><FormattedMessage id={'couponCode'}/></Label>
                    <input className="form-control"
                           value={this.state.coupon_code !== undefined ? this.state.coupon_code : this.props.editing_coupon}
                           onInput={this.onInput}/>
                </div>
                {
                    this.state.error && <p className={'text-danger'}>{this.state.error}</p>
                }
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        my_coupons: state.settings.my_coupons || [],
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateSetting: (change) => dispatch(actionMergeSetting(change))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomCouponModal);
